import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralDemandLevelSignature {
  Args: {
    demandChange: 'increase' | 'decrease' | '';
    demandLevel: number;
    size: 'small' | 'normal';
  };
}

export default class GeneralDemandLevel extends Component<GeneralDemandLevelSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get demandChange() {
    return this.args.demandChange;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get demandLevel() {
    return this.args.demandLevel;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get demandLevelLabel() {
    if (this.demandLevel) {
      return this.intl.t(`market_insight.rate_level.level${this.demandLevel}`);
    }

    return this.intl.t('general.missing');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconColor() {
    if (this.demandChange === 'increase') {
      return 'success';
    }

    return 'critical';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconName() {
    if (this.demandChange === 'increase') {
      return 'arrow-up';
    }

    return 'arrow-down';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get size() {
    return this.args.size;
  }

  <template>
    <div class="flex flex-row items-center">
      <div
        class="demand-change-indicator--{{this.size}}
          demand-main-bg-color--level-{{this.demandLevel}}
          mr-100"
      ></div>
      <span>{{this.demandLevelLabel}}</span>

      {{#if this.demandChange}}
        <div class="ml-100">
          <PrismIcon
            @color={{this.iconColor}}
            @name={{this.iconName}}
            @size="small"
          />
        </div>
      {{/if}}
    </div>
  </template>
}
